import axios from "axios";
import { BaseURL } from "../utils/appConstant";

const apiClient = axios.create({
    baseURL: BaseURL,
    withCredentials: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});
function getCookieByKey(key: string) {
    const cookies = document.cookie.split(";"); // Split all cookies into an array
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim(); // Remove leading/trailing spaces
      if (cookie.startsWith(`${key}=`)) {
        return cookie.substring(key.length + 1); // Extract and return the value
      }
    }
    return null; // Return null if the cookie is not found
  }
  // Request Interceptor
  apiClient.interceptors.request.use(
    (config) => {
      // checking if token or mentee email is not available in localStorage or not
      const accessToken = getCookieByKey("access_token_cookie");
  
      if (accessToken === null || config.url?.includes("undefined")) {
        // window.location.href = "/#/login";
      }
  
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

apiClient.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.response?.status === 401 || error.response?.status === 422) {
        window.location.href = "/#/user_login";
      }
  
      return Promise.reject(error); 
    }
  );
export default apiClient;